import React from 'react';
import { PropTypes } from 'prop-types';
import _ from 'lodash';
import EmptyCard from '../../components/EmptyCard';
import Card from '../../components/Card';
import AddInfo from '../../components/AddInfo';
import styles from './OrderInfo.css';

const CcInfo = ({
  paymentInfo: { creditCardNumber },
  onEditBilling,
  onEditCreditCardList,
  hasShippingInfo,
  hasPaymentInfo,
  cardType,
}) =>
  !hasPaymentInfo ? (
    <EmptyCard title="Payment" titleCentered inactive={!hasShippingInfo}>
      <AddInfo onClick={onEditBilling} disabled={!hasShippingInfo} />
    </EmptyCard>
  ) : (
    <Card
      title="Payment Info"
      onEdit={onEditCreditCardList}
      editLabel="Change/Add Card"
    >
      <p className={styles.endingInText}>
        {cardType} ending in
        <span className={styles.creditCardNumber}>
          {_.slice(creditCardNumber, creditCardNumber.length - 4)}
        </span>
      </p>
      <hr className={styles.hrStyles} />
      <div className={styles.flexWrapper} />
    </Card>
  );

CcInfo.propTypes = {
  paymentInfo: PropTypes.object,
  onEditBilling: PropTypes.func.isRequired,
  onEditCreditCardList: PropTypes.func.isRequired,
  hasShippingInfo: PropTypes.bool,
  hasPaymentInfo: PropTypes.bool,
  cardType: PropTypes.string,
};

export default CcInfo;



// WEBPACK FOOTER //
// ./src/containers/CartPage/CcInfo.jsx